import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = ["placeholder"]
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = ["min"]
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "char-count" }
const _hoisted_8 = { class: "form-actions" }

import { ref, computed, watch } from 'vue';
import AppButton from '@/components/base/AppButton.vue';
import AppModal from '@/components/base/Modal.vue';
import type { ProvisioningRequestData } from '@/types/services';

interface Props {
  isVisible?: boolean;
}

interface Emits {
  (e: 'cancel'): void;
  (e: 'submit', payload: { data: ProvisioningRequestData; isValid: boolean }): void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ProvisioningRequestModal',
  props: {
    isVisible: { type: Boolean, default: false }
  },
  emits: ["cancel", "submit"],
  setup(__props: any, { emit: __emit }) {

// @ts-ignore
const props = __props;

const emit = __emit;

// Form data
const formData = ref<ProvisioningRequestData>({
  requestedAmount: 0,
  description: '',
  provisionDeadline: new Date().toISOString().split('T')[0]
});

// Computed
const minDate = computed(() => {
  // Deadline must be today or in the future
  return new Date().toISOString().split('T')[0];
});

const isFormValid = computed(() => {
  return (
    formData.value.requestedAmount > 0 &&
    formData.value.description.trim().length > 0 &&
    formData.value.description.length <= 1000 &&
    formData.value.provisionDeadline.length > 0
  );
});

// Methods
const handleCancel = () => {
  resetForm();
  emit('cancel');
};

const handleSubmit = () => {
  if (!isFormValid.value) {
    emit('submit', { data: formData.value, isValid: false });
    return;
  }
  
  emit('submit', { data: formData.value, isValid: true });
};

const resetForm = () => {
  formData.value = {
    requestedAmount: 0,
    description: '',
    provisionDeadline: new Date().toISOString().split('T')[0]
  };
};

// Watch for modal visibility changes to reset form
watch(() => props.isVisible, (newVal:boolean) => {
  if (newVal) {
    resetForm();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(AppModal, {
      isVisible: _ctx.isVisible,
      title: _ctx.$t('provisioning.requestTitle'),
      onCancel: handleCancel
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _withModifiers(handleSubmit, ["prevent"]),
          class: "finance-form"
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("label", null, [
              _createTextVNode(_toDisplayString(_ctx.$t('provisioning.amount')) + " ", 1),
              _cache[3] || (_cache[3] = _createElementVNode("span", { class: "required" }, "*", -1))
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "number",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.requestedAmount) = $event)),
              step: "0.01",
              min: "0.01",
              required: "",
              class: "form-input",
              placeholder: _ctx.$t('provisioning.amountPlaceholder')
            }, null, 8, _hoisted_2), [
              [_vModelText, formData.value.requestedAmount]
            ])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("label", null, [
              _createTextVNode(_toDisplayString(_ctx.$t('provisioning.provisionDeadline')) + " ", 1),
              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "required" }, "*", -1))
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "date",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.provisionDeadline) = $event)),
              required: "",
              class: "form-input",
              min: minDate.value
            }, null, 8, _hoisted_4), [
              [_vModelText, formData.value.provisionDeadline]
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("label", null, [
              _createTextVNode(_toDisplayString(_ctx.$t('provisioning.description')) + " ", 1),
              _cache[5] || (_cache[5] = _createElementVNode("span", { class: "required" }, "*", -1))
            ]),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.description) = $event)),
              class: "form-input",
              required: "",
              maxlength: "1000",
              rows: "4",
              placeholder: _ctx.$t('provisioning.descriptionPlaceholder')
            }, null, 8, _hoisted_6), [
              [_vModelText, formData.value.description]
            ]),
            _createElementVNode("small", _hoisted_7, _toDisplayString(formData.value.description.length) + " / 1000 " + _toDisplayString(_ctx.$t('common.characters')), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(AppButton, {
              type: "button",
              variant: "outline",
              onClick: handleCancel
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
              ]),
              _: 1
            }),
            _createVNode(AppButton, {
              type: "submit",
              variant: "primary",
              disabled: !isFormValid.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('provisioning.submit')), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ], 32)
      ]),
      _: 1
    }, 8, ["isVisible", "title"])
  ]))
}
}

})